import { render, staticRenderFns } from "./waterfall.vue?vue&type=template&id=4d295e50&"
import script from "./waterfall.vue?vue&type=script&lang=js&"
export * from "./waterfall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports